<template>
  <div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <div class="d-none d-lg-flex col-lg-8 align-items-center">
              <div
                class="
                  w-100
                  d-lg-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img :src="$assets('images/connexion.png')" alt="Login V2" />
              </div>
            </div>
            <div class="d-flex col-lg-4 auth-bg">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 mx-auto mt-3">
                <a href="/">
                  <img
                    style="cursor: pointer"
                    @click="login()"
                    class="img-fluid"
                    :src="$assets('images/logo.png')"
                    alt=""
                  />
                </a>
                <form
                  v-if="state === 1"
                  class="auth-login-form mt-3"
                  autocomplete="off"
                >
                  <div class="mb-2">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.17034 1.10096C6.47292 1.40355 6.47292 1.89414 6.17034 2.19672L2.06931 6.29775L6.17034 10.3988C6.47292 10.7014 6.47292 11.192 6.17034 11.4945C5.86775 11.7971 5.37717 11.7971 5.07458 11.4945L0.42567 6.84563C0.123084 6.54305 0.123084 6.05246 0.42567 5.74987L5.07458 1.10096C5.37717 0.798377 5.86775 0.798377 6.17034 1.10096Z"
                        fill="black"
                      />
                    </svg>
                    <span style="font-size: 12px; cursor: pointer"
                      ><a :href="backLogin()"
                        ><u style="color: #5e5873">Retour</u></a
                      ></span
                    >
                  </div>
                  <h4 class="card-title font-weight-bold mb-1">
                    Création de compte
                  </h4>
                  <div class="form-group">
                    <label class="form-label">Téléphone</label>
                    <div class="input-group input-group-merge">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.4999 12.6901V14.9401C16.5008 15.1489 16.458 15.3557 16.3743 15.5471C16.2907 15.7385 16.1679 15.9103 16.014 16.0515C15.8601 16.1927 15.6784 16.3002 15.4805 16.3671C15.2826 16.434 15.073 16.4589 14.8649 16.4401C12.5571 16.1893 10.3402 15.4007 8.39245 14.1376C6.58032 12.9861 5.04395 11.4497 3.89245 9.63757C2.62493 7.68098 1.83613 5.45332 1.58995 3.13507C1.57121 2.92767 1.59586 2.71864 1.66233 2.52129C1.72879 2.32394 1.83563 2.14259 1.97602 1.98879C2.11642 1.83499 2.2873 1.7121 2.47779 1.62796C2.66828 1.54382 2.87421 1.50027 3.08245 1.50007H5.33245C5.69643 1.49649 6.04929 1.62538 6.32527 1.86272C6.60125 2.10006 6.78151 2.42966 6.83245 2.79007C6.92742 3.51012 7.10354 4.21712 7.35745 4.89757C7.45836 5.16602 7.4802 5.45776 7.42038 5.73823C7.36056 6.01871 7.2216 6.27616 7.01995 6.48007L6.06745 7.43257C7.13512 9.31023 8.68979 10.8649 10.5675 11.9326L11.5199 10.9801C11.7239 10.7784 11.9813 10.6395 12.2618 10.5796C12.5423 10.5198 12.834 10.5417 13.1024 10.6426C13.7829 10.8965 14.4899 11.0726 15.21 11.1676C15.5743 11.219 15.907 11.4025 16.1448 11.6832C16.3827 11.9639 16.5091 12.3223 16.4999 12.6901Z"
                              stroke="#4B4B4B"
                              stroke-opacity="0.65"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg>&nbsp;
                          <input
                            type="number"
                            style="width: 50px; border-width: 0; height: 20px"
                            class="form-control"
                            v-model="form.indic"
                          />
                        </span>
                      </div>
                      <input
                        v-model="form.username"
                        class="form-control"
                        type="number"
                      />
                    </div>
                    <div v-if="errors.username" style="color: red">
                      {{ errors.username[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    @click.prevent="checkPhone()"
                    class="btn btn-primary btn-block"
                  >
                    Valider
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>

                <form
                  v-if="state === 2"
                  class="auth-login-form mt-3"
                  autocomplete="off"
                >
                  <div class="mb-2">
                    <svg
                      width="7"
                      height="12"
                      viewBox="0 0 7 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6.17034 1.10096C6.47292 1.40355 6.47292 1.89414 6.17034 2.19672L2.06931 6.29775L6.17034 10.3988C6.47292 10.7014 6.47292 11.192 6.17034 11.4945C5.86775 11.7971 5.37717 11.7971 5.07458 11.4945L0.42567 6.84563C0.123084 6.54305 0.123084 6.05246 0.42567 5.74987L5.07458 1.10096C5.37717 0.798377 5.86775 0.798377 6.17034 1.10096Z"
                        fill="black"
                      />
                    </svg>
                    <span style="font-size: 12px; cursor: pointer"
                      ><u @click.prevent="backPhone()">Retour</u></span
                    >
                  </div>
                  <h4 class="card-title font-weight-bold mb-1">
                    Création de compte
                  </h4>
                  <p>
                    Veuillez entrer le code que vous avez reçu sur le N° de
                    téléphone {{ form.username }}
                  </p>
                  <div class="form-group">
                    <label class="form-label">Code</label>
                    <div class="input-group input-group-merge">
                      <div class="input-group-prepend">
                        <span class="input-group-text">
                          <svg
                            width="15"
                            height="15"
                            viewBox="0 0 15 15"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0)">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M3.30242 7.36828C2.98148 7.36828 2.72131 7.62846 2.72131 7.9494V12.0172C2.72131 12.3381 2.98148 12.5983 3.30242 12.5983H11.438C11.759 12.5983 12.0191 12.3381 12.0191 12.0172V7.9494C12.0191 7.62846 11.759 7.36828 11.438 7.36828H3.30242ZM1.55908 7.9494C1.55908 6.98658 2.3396 6.20605 3.30242 6.20605H11.438C12.4008 6.20605 13.1814 6.98658 13.1814 7.9494V12.0172C13.1814 12.98 12.4008 13.7605 11.438 13.7605H3.30242C2.3396 13.7605 1.55908 12.98 1.55908 12.0172V7.9494Z"
                                fill="black"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M7.37047 2.13806C6.75399 2.13806 6.16275 2.38295 5.72683 2.81887C5.29091 3.25479 5.04602 3.84603 5.04602 4.46251V6.78697C5.04602 7.10791 4.78584 7.36808 4.4649 7.36808C4.14396 7.36808 3.88379 7.10791 3.88379 6.78697V4.46251C3.88379 3.53779 4.25113 2.65094 4.90501 1.99706C5.55889 1.34318 6.44575 0.97583 7.37047 0.97583C8.2952 0.97583 9.18205 1.34318 9.83593 1.99706C10.4898 2.65094 10.8572 3.53779 10.8572 4.46251V6.78697C10.8572 7.10791 10.597 7.36808 10.276 7.36808C9.9551 7.36808 9.69493 7.10791 9.69493 6.78697V4.46251C9.69493 3.84603 9.45003 3.25479 9.01411 2.81887C8.57819 2.38295 7.98696 2.13806 7.37047 2.13806Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect
                                  width="13.9467"
                                  height="13.9467"
                                  fill="white"
                                  transform="translate(0.396973 0.394775)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </span>
                      </div>
                      <input
                        class="form-control"
                        v-model="form.code"
                        type="number"
                      />
                    </div>
                    <div v-if="errors.code" style="color: red">
                      {{ errors.code[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    class="btn btn-primary btn-block"
                    @click.prevent="verifyCode()"
                  >
                    Vérifier
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>

                <form
                  v-if="state === 3"
                  class="auth-login-form mt-3"
                  autocomplete="off"
                >
                  <h4 class="card-title font-weight-bold mb-1">
                    Création de compte
                  </h4>
                  <div class="form-group">
                    <label class="form-label">Nom</label>
                    <input class="form-control" v-model="form.last_name" />
                    <div v-if="errors.last_name" style="color: red">
                      {{ errors.last_name[0] }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Prénom</label>
                    <input class="form-control" v-model="form.first_name" />
                    <div v-if="errors.first_name" style="color: red">
                      {{ errors.first_name[0] }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <input class="form-control" v-model="form.email" />
                    <div v-if="errors.email" style="color: red">
                      {{ errors.email[0] }}
                    </div>
                  </div>
                  <div v-if="recommandation" class="form-group">
                    <label class="form-label">Avez-vous etez recommandé ?</label>
                    <select name="" class="form-control" >
                        <option readonly v-if="user.complet_name !== ''" :value="user.complet_name">{{user.complet_name}}</option>
                        <option v-else :value="user.complet_name">{{user.complet_name}}</option>
                    </select>
                  </div>
                  <div v-if="recommandation===false" class="form-group">
                    <label class="form-label">Avez-vous etez recommandé ?</label>
                    <select name="" class="form-control" id="recommande_info" @change="getIdandName">
                        <option readonly v-if="user.complet_name !== ''" :value="user.complet_name">{{user.complet_name}}</option>
                        <option v-else :value="user.complet_name">{{user.complet_name}}</option>
                        <option v-for="(intermed,key) in intermediaires" :key="key" :value="intermed.id">
                          <span v-if="intermed.last_name === null && intermed.first_name=== null">{{intermed.nom_entreprise}}</span>
                          <span v-else>{{intermed.last_name}} {{intermed.first_name}}</span>
                        </option>
                    </select>
                  </div>
                  <button
                    v-if="!loading"
                    class="btn btn-primary btn-block"
                    @click.prevent="register()"
                  >
                    Valider
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>

                <form
                  v-if="state === 4"
                  class="auth-login-form mt-3"
                  autocomplete="off"
                >
                  <h4 class="card-title font-weight-bold mb-1">
                    Création de compte
                  </h4>
                  <div class="form-group">
                    <label class="form-label">Mot de Passe</label>
                    <input type="password" class="form-control" v-model="form.password" />
                    <div v-if="errors.password" style="color: red">
                      {{ errors.password[0] }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Confirmer Mot de Passe</label>
                    <input type="password" class="form-control" v-model="form.conf_password" />
                    <div v-if="errors.conf_password" style="color: red">
                      {{ errors.conf_password[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    class="btn btn-primary btn-block"
                    @click.prevent="registerPassword()"
                  >
                    Valider
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>

                <p v-if="state !== 4" class="text-center mt-2">
                  <span>Déjà inscrit ?</span>
                  <a :href="backLogin()"
                    ><span style="color: #002a85">
                      <u>Se connecter</u>
                    </span>
                  </a>
                </p>
                <p class="text-center mt-2">
                  <span style="font-size: 12px"
                    >En utilisant cette application, vous acceptez nos
                    <a
                      :href="$assets('terms')"
                      target="_blank"
                      style="color: #002a85"
                      >conditions d'utilisation</a
                    ></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../../../helpers/shared";
import axios from "axios";
export default {
  name: "register-phone",
  props: {
    route: {
      type: String,
      default: () => "",
    },
   /*  id_user:'',
    first_name:'',
    last_name:'', */
  },
  data: () => ({
    state: 1,
    loading: false,
    router: {},
    form: {
      username: "",
      code: "",
      last_name: "",
      first_name: "",
      email: "",
      indic: 228,
      password:"",
      conf_password:"",
      user_refer:'',
      
    },
    errors: [],
    id: null,
    user:{
        complet_name:'',
    },
    recommandation:false,
    id_user:'',
    first_name:'',
    last_name:'',
    nom_entreprise:'',
    intermediaires:[],
    selected_intermediaire:{
      id:'',
      name:'',
    },
    showTheUser:false,
    shoTheSelect:false,
  }),
  methods: {
    checkPhone() {
      this.loading = true;
      axios
        .post(api("auth/register"), {
          step: 1,
          username: this.form.username,
          indic: this.form.indic,
        })
        .then((response) => {
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.state = 2;
            this.getUuidInfo()
            
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },

    verifyCode() {
      this.loading = true;
      axios
        .post(api("auth/register"), {
          step: 2,
          username: this.form.username,
          code: this.form.code,
        })
        .then((response) => {
          localStorage.setItem('auth', JSON.stringify(response.data))
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.id = response.data.unique;
            this.state = 3;
              this.intermediaireSimpleListe()
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },
    
    register() {
      this.loading = true;
      axios
        .post(api("auth/register"), {
          step: 3,
          last_name: this.form.last_name,
          first_name: this.form.first_name,
          email: this.form.email,
          unique: (this.id),
          user_refer:this.user.complet_name,
          id_refer : this.id_user
        })
        .then((response) => {
          localStorage.setItem('auth', JSON.stringify(response.data))
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.state = 4;
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },

    registerPassword() {
      this.loading = true;
      axios
        .post(api("auth/register"), {
          step: 4,
          password: this.form.password,
          conf_password: this.form.conf_password,
          unique: this.id,
        })
        .then((response) => {
          localStorage.setItem('auth', JSON.stringify(response.data))
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            window.location.href = "/administration/dashboard";
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },

    getUuidInfo(url ='uuid-info'){
              axios.get(api(url),)
                    .then(response => {
                      //console.log("Valeur de response.data dans getUuidInfo:",response.data)
                        this.id_user = response.data.id_user,
                        this.first_name = response.data.first_name,
                        this.last_name = response.data.last_name,
                        this.nom_entreprise = response.data.nom_entreprise
                        /* console.log("valeur de id_user",this.id_user)
                        console.log("valeur de first_name",this.first_name)
                        console.log("valeur de last_name",this.last_name) */
                        /**************************************************************/
                        if(this.id_user !== "" && this.first_name !== "" && this.last_name !==""){
                            this.recommandation = true
                            if(this.first_name === null && this.last_name === null && this.nom_entreprise !== null){
                              this.user.complet_name = this.nom_entreprise
                            }else{
                              this.user.complet_name = this.first_name+' '+this.last_name
                              //console.log("Premier Executé")
                            }
                        }else{
                            this.recommandation = false
                            this.user.complet_name = "Moi meme"
                            //console.log("Deuxieme Executé")
                            //console.log("je suis executé dans else")
                        }
                        /**************************************************************/
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
    },
    intermediaireSimpleListe(url='intermediaire/simpleList'){
      axios.get(api(url),)
                    .then(response => {
                      let content = response.data
                      this.intermediaires = content
                      //console.log("Valeur de response.data dans intermediaireSimpleListe:",response.data)
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
    },
    getIdandName(){
      let ri = document.querySelector("#recommande_info");
      
      /* console.log("Valeur de recommande_info:",ri)
      console.log("Valeur de recommande_info name:",ri.selectedOptions[0].innerHTML)
      console.log("Valeur de recommande_info id:",ri.value) */
      this.selected_intermediaire.id = ri.value
      this.selected_intermediaire.name = ri.selectedOptions[0].textContent
      /* console.log("valeur de this.selected_intermediaire.id :",this.selected_intermediaire.id)
      console.log("this.selected_intermediaire.name :",this.selected_intermediaire.name) */
        this.user.complet_name=this.selected_intermediaire.name,
        this.id_user=this.selected_intermediaire.id
      /* console.log("valeur de this.user.complet_name :",this.user.complet_name)
      console.log("valeur de this.id_user :",this.id_user) */
                        if(this.id_user !== "" && this.first_name !== "" && this.last_name !==""){
                            this.recommandation = true
                            this.user.complet_name = this.first_name+' '+this.last_name
                        }else if((this.id_user === "" && this.first_name === "" && this.last_name ==="")){
                              this.recommandation = true
                            if(this.selected_intermediaire.id=== "" && this.selected_intermediaire.name===""){
                               this.user.complet_name = "Moi meme"
                            }else{
                              this.user.complet_name = this.selected_intermediaire.name
                              this.id_user = this.selected_intermediaire.id
                            }
                        }
    },
    nextStep() {
      this.state = 2;
    },
    backLogin() {
      return this.router.login;
    },
    backPhone() {
      this.form.username = "";
      this.state = 1;
    },
    login() {
      window.location.href = this.router.login;
    },
  },
  mounted() {
    this.router = JSON.parse(this.route);
    //this.intermediaireSimpleListe()
    //console.log("valeur de this.router:",this.router)
    
  },
};
</script>

<style scoped>
</style>
